/* eslint-disable promise/always-return */
import { axiosMM } from "./axiosCreator";
import { store } from "../react-app";
import {
	SEARCH_FLIGHTS_API,
	SEARCH_METASEARCH_API,
	CHECKOUT_API,
	USER_API,
	LEGACY_API,
	BFF_API,
	UPDATE_FLIGHT,
	CORONAVIRUS_DEADLINE_URL,
	BFF_MALL_API
} from "./constants";

/**
 * Subscribe na newsletter
 * @param {String} email
 */
export const newsletterRegister = email => {
	const authOptions = {
		url: "/cadastro-email-marketing",
		method: "POST",
		data: { email: email },
		dataType: "json"
	};
	return axiosMM(authOptions);
};

/**
 * Envia credenciais do facebook para login
 * @param {Object} facebookCredentials
 */
export const sendFacebookCredentials = facebookCredentials =>
	axiosMM.post("/connect", facebookCredentials.authResponse);

export const getFacebookUserData = token =>
	axiosMM.get(`https://graph.facebook.com/me?access_token=${token}`);

/**
 * Envia uma requisição pra verificar se o token do usuário é válido
 * @param {String} token
 */
export const pingUser = token => axiosMM.get("/is_granted", { headers: { authorization: token } });

/**
 * Envia uma requisição pra recuperar o token de um usuário logado no PHP
 */
export const recoverUserTokenIfisLogged = () => axiosMM.get("/generate_token");

/**
 * Retorna os voos passados como argumento, ademais taxas de serviço
 * @param {Array} flightIDs array de flight IDs
 * @param {String} searchIntentionID hash da intenção de busca
 * @param {Boolean} isMetasearch identifica origem metasearch
 */
export const getFlightCheckoutDetails = (
	flightIDs = [],
	searchIntentionID,
	isMetasearch = false
) => {
	const api = isMetasearch ? SEARCH_METASEARCH_API : SEARCH_FLIGHTS_API;
	return axiosMM.get(`${api}/search/${searchIntentionID}?flightId=${flightIDs.join("&flightId=")}`, { headers: { Authorization: "JWT " + window.searchToken } });
};

export const getFlightDetails = (
	flightIDs = [],
	searchIntentionID,
	selectedFlights,
	flightDirection
) => {
	let ids = [];

	if (selectedFlights.outbound.length > 0) ids.push(selectedFlights.outbound[0].id);
	if (selectedFlights.inbound.length > 0) ids.push(selectedFlights.inbound[0].id);

	if (flightDirection === "outbound") {
		ids[0] = flightIDs[0];
	} else {
		ids[1] = flightIDs[0];
	}

	// eslint-disable-next-line promise/catch-or-return
	getFlightCheckoutDetails(ids, searchIntentionID).then(response => {
		store.dispatch({
			type: UPDATE_FLIGHT,
			flights: response.data.flights
		});
	});
};

/**
 * Consulta o endereço do usuário no momento do checkout
 * @param {String} checkoutId string do checkout (pode ser encontrada em sessionStorage)
 * @param {String} token token de usuário logado (pode ser encontrado em localStorage - au)
 */

export const getUserAddress = (checkoutId, token) =>
	axiosMM.get(`${CHECKOUT_API}/checkouts/${checkoutId}/users/addresses`, {
		headers: { authorization: token }
	});

/**
 * Consulta todas as compras de um usuário
 * @param {String} token token de usuário logado (pode ser encontrado em localStorage - au)
 */
export const getUserOrders = token =>
	axiosMM.get("/purchases", {
		headers: { authorization: token, mobile: true }
	});

/**
 * Faz o get do cálculo de cancelamento pra uma compra específica
 * @param {String} token token de usuário logado (pode ser encontrado em localStorage - au)
 * @param {String} orderCode código da compra a solicitar
 */
export const calcOrderCancelation = (token, orderCode) =>
	axiosMM.get(`/purchases/${orderCode}`, {
		headers: { authorization: token, mobile: true }
	});

/**
 * Cancela uma compra específica
 * @param {String} token token de usuário logado (pode ser encontrado em localStorage - au)
 * @param {String} passwordConfirmationToken gerado após confirmação de senha
 * @param {String} orderCode código da compra a solicitar
 * @param {Object} bankData Dados bancários para tranferência se houver
 */
export const cancelOrder = (token, passwordConfirmationToken, orderCode, bankData, infoData) => {
	const authOptions = {
		method: "DELETE",
		url: `/purchases/${orderCode}`,
		data: {
			bankData: bankData,
			infoData: infoData
		},
		headers: {
			Authorization: token,
			passwordConfirmationToken: passwordConfirmationToken,
			mobile: true
		}
	};

	return axiosMM(authOptions);
};

export const confirmPasswordInCancellation = (token, purchaseToken, password, orderCode) => {
	const authOptions = {
		method: "POST",
		url: "/confirm_password",
		data: {
			password: password,
			purchaseId: orderCode
		},
		headers: {
			Authorization: token,
			purchaseToken: purchaseToken
		}
	};

	return axiosMM(authOptions);
};

/**
 * Consulta todas os programas de fidelidade
 * @param {String} token token de usuário logado (pode ser encontrado em localStorage - au)
 */
export const getAllProgramFidelity = () =>
	axiosMM.get("/customer/my-sales/get-all-program-fidelity");

/**
 * Consulta dados de vendas do usuário filtrando por data e programa de fidelidade
 * @param {String} token token de usuário logado (pode ser encontrado em localStorage - au)
 * @param {String} programId id do programa de fidelidade
 * @param {String} startDate data início para filtrar
 * @param {String} orendDatederCode data fim para filtrar
 */
export const getSalesReport = (token, programId, dateInit, dateFinish) =>
	axiosMM.get(
		`/customer/my-sales/sales-reports?programId=${programId}${
			dateInit ? `&dateInit=${dateInit}` : ""
		}${dateFinish ? `&dateFinish=${dateFinish}` : ""}`
	);

export const sendAfterPaymentQuest = (answer, idForms, idOrder, idUser) => {
	return axiosMM.post(`${LEGACY_API}/ajax-save-poll-payment`, {
		data: answer,
		idforms: idForms,
		idorder: idOrder,
		idusers: idUser
	});
};

export const getAffiliateName = () => {
	return axiosMM.get("/check-affiliate-program");
};

export const sendAffiliateStatus = active => {
	return axiosMM.post("/activate-affiliate-program", { active: active });
};

export const getCheckoutById = checkoutId => axiosMM.get(`${CHECKOUT_API}/checkouts/${checkoutId}`);

export const getAddressFromCEP = cepNumber => axiosMM.get(`/search-cep?cep=${cepNumber}`);

export const getComboCidades = uf => axiosMM.get(`/search-cities?uf=${uf}`);

export const registerUser = userData => axiosMM.post("/cadastro", userData);

export const logoutUser = () => axiosMM.post("/logout");

/**
 * Send recovery link password with instruction to set new password.
 *
 * @param {string} email Send recovery password to this email
 */
export const sendRecoveryPasswordLink = email =>
	axiosMM.get(`${USER_API}/auth/send-reset-password-email/${email}`);

/**
 * Reset the user password
 *
 * @param {string} token - The token used for reset the password
 * @param {string} password - New user password
 */
export const resetPassword = (token, password) =>
	axiosMM.post(`${USER_API}/auth/reset-password`, {
		password,
		token
	});

export const checkIfSsnExists = (type, number) =>
	axiosMM.post("/check-ssn", { type: type, ssn: number });

export const checkIfEmailExists = email => axiosMM.post("/check-email", { email });

export const checkIfLoginExists = login => axiosMM.post("/check-login", { login });

export const getAirport = airport => axiosMM.get(`/airports/search/${airport}`);

export const createPriceAlert = alert => axiosMM.post(`${BFF_API}/alerts`, alert);

export const getPriceAlert = id => axiosMM.get(`${BFF_API}/alerts/${id}`);

export const disablePriceAlert = (id, reason) =>
	axiosMM.delete(`${BFF_API}/alerts/${id}?reason=${reason}`);

export const getPriceAlertCompare = id => axiosMM.get(`${BFF_API}/v2/alerts/${id}/compare-price`);

export const createAirBridge = data => axiosMM.post(`${BFF_API}/alerts/bulkcreate`, data);

export const getCancellationRules = token => axiosMM.get('/purchases/cancellation/require/parameters', {
	headers: { authorization: token, mobile: true }
});

export const postCancellationProtocol = data => axiosMM.post(`/purchases/protocol-request`, data);

export const uploadImage = data => axiosMM.post(`/purchases/protocol-request/uploads`, data);

export const getCovidLimitDateByAirline = () => axiosMM.get(CORONAVIRUS_DEADLINE_URL);

export const getCancellationTerm = (token, type, id) => axiosMM.get(`/cancellation-term?type=${type}&purchaseId=${id}`, {
	headers: { authorization: token, mobile: true }
});

export const getDynamicFormContext = (token, params) => {
	return axiosMM.post(
		`/service-operations/contexts`,
		params, {
			headers: { authorization: token }
		}
	);
};

export const getDynamicFormCategories = (token, contextToken, correlationId) => {
	return axiosMM.get(
		`/service-operations/contexts/categories`,
		{	headers: {
			'VND-ApiServiceOperation-ContextToken': contextToken,
			'X-Correlation-ID': correlationId,
			authorization: token
		}}
	);
};

export const getDynamicFormCategorieRules = (id, params, contextToken, correlationId) => {
	return axiosMM.post(
		`/service-operations/contexts/rules/${id}/request`,
		params, {
			headers: {
				'VND-ApiServiceOperation-ContextToken': contextToken,
				'X-Correlation-ID': correlationId,
			}
		}
	);
};

export const getDynamicFormCategorieSchemas = (id, correlationId) => {
	return axiosMM.get(
		`/service-operations/schemas/${id}/raw`,
		{	headers: { 'X-Correlation-ID': correlationId }}
	);
};

export const getRebookingTrips = token => axiosMM.get(
	'/rebooking',
	{ headers: { authorization: token } }
);

export const getRebookingTransaction = (token, id) => axiosMM.get(
	`/rebooking/${id}`,
	{ headers: { authorization: token } }
);

export const getRebookingToken = (token, params) => axiosMM.post(
	'/rebooking/token',
	params,
	{ headers: { authorization: token } }
);